import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";

function SingleAnnouncement({page_title}) {

    useEffect(() => {
                        document.title = page_title;
                    }, [page_title]);


    const { id } = useParams();
    const [announcement, setAnnouncement] = useState([]);
    
    useEffect(() => {
        fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=getAnnouncementById&id=${id}`)
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
            setAnnouncement(data.announcement);
            } else {
            console.error("API error:", data.error);
            }
        })
        .catch((err) => console.error("Fetch error:", err));
    }, [id])
    
        const formatDate = (dateString) => {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = date.toLocaleString('en-US', { month: 'short' });
            const year = date.getFullYear();
    
            return `${day}-${month}-${year}`;
        };


    return (
      <>
        <div className='instructions_section'>
            <div className="instructions_wrapper single_ann_wrap">
                <h2 className='instructions_title'>
                    {announcement.title}
                </h2>

                <hr class="instructions_hr"/>

                <p className='onea_date'>
                    <span className="fa-regular fa-calendar"></span>&nbsp;{formatDate(announcement.date)}
                </p>

                <p className='onea_content single_content_body'>
                    {announcement.body}
                </p>

                <hr class="instructions_hr single_content_hr"/>

                <div className='ann_link_wrapper'>
                    <Link to="/announcements" className='ann_link'>All Announcements&nbsp;&nbsp;<span className="fa-solid fa-angle-right"></span></Link>
                </div>
            </div>
        </div>
      </>
    );
}

export default SingleAnnouncement;